import { createContext, useContext } from "react";

import type { ReactNode } from "react";

type NotificationsPanelOptions = {
  /** Let notification text wrap instead of truncating to one line. */
  disableTruncate: boolean;
  /** Stay on the panel after an action (e.g. accepting an invite) instead of navigating to its result. */
  disableNavigation: boolean;
};

const DEFAULT_OPTIONS: NotificationsPanelOptions = {
  disableTruncate: false,
  disableNavigation: false,
};

const NotificationsPanelOptionsContext = createContext<NotificationsPanelOptions>(DEFAULT_OPTIONS);

/**
 * Presentation options for a `NotificationsPanel` subtree. The sidebar renders
 * without a provider and gets the defaults; hosts with different layout needs
 * (e.g. the mobile WebView) wrap the panel to override them, so the items
 * don't have to thread the options down as props.
 */
export function NotificationsPanelOptionsProvider({
  children,
  ...options
}: Partial<NotificationsPanelOptions> & { children: ReactNode }) {
  return (
    <NotificationsPanelOptionsContext.Provider value={{ ...DEFAULT_OPTIONS, ...options }}>
      {children}
    </NotificationsPanelOptionsContext.Provider>
  );
}

export function useNotificationsPanelOptions(): NotificationsPanelOptions {
  return useContext(NotificationsPanelOptionsContext);
}
